import React from 'react';

import { useSelector } from '@hh.ru/front-static-app';
import { BreakpointProvider, SnackbarContextProvider } from '@hh.ru/magritte-ui';
import BlokoBreakpointProvider from 'bloko/blocks/breakpointProvider';

import { PageHead, PageTitle, PageMeta } from 'src/app/layouts/PageHead';

interface PageLayoutProps {
    /** Заголовок страницы*/
    title?: string;
    /** Обвязка содержимого страницы */
    layout?: React.ComponentType;
    /** Обертка для показа ошибки */
    errorWrapper?: React.ComponentType;
}

const DefaultLayout: React.FC<React.PropsWithChildren> = ({ children }) => {
    return <>{children}</>;
};

const PageLayout: React.FC<PageLayoutProps & React.PropsWithChildren> = ({
    children,
    layout: LayoutComponent = DefaultLayout,
    errorWrapper: ErrorWrapperComponent = DefaultLayout,
    ...layoutProps
}) => {
    const { title } = layoutProps;
    const renderRestriction = useSelector(({ renderRestriction }) => renderRestriction);

    const content = (
        <>
            {title && (
                <PageHead>
                    <PageTitle>{title}</PageTitle>
                    <PageMeta property="og:title" content={title} />
                </PageHead>
            )}
            <BreakpointProvider storedBreakpointValue={renderRestriction.magritteBreakpoint}>
                <BlokoBreakpointProvider>
                    <SnackbarContextProvider>
                        <LayoutComponent {...layoutProps}>{children}</LayoutComponent>
                    </SnackbarContextProvider>
                </BlokoBreakpointProvider>
            </BreakpointProvider>
        </>
    );

    return <ErrorWrapperComponent>{content}</ErrorWrapperComponent>;
};

export default PageLayout;
